/* Royal Kronleuchter – Erlebnis „reise“ (Die Reise ins Kristall), Vertrag: erlebnis/VERTRAG.md */
(function () {
	'use strict';
	var SEL = 'section.rk-erl[data-typ="reise"]', ROEM = 'I II III IV V'.split(' '), M = Math, D = document, AH = { 'aria-hidden': 'true' }, alle = [];
	var mq = matchMedia('(prefers-reduced-motion: reduce)');
	var DOE = window.DeviceOrientationEvent, fragen = !!(DOE && typeof DOE.requestPermission === 'function');
	var neig = { ok: !!DOE && !fragen };
	var an = (t, f) => addEventListener(t, f, { passive: true }), ab = (t, f) => removeEventListener(t, f);
	var auf = (n, t, f) => n.addEventListener(t, f);

	function klemm(v, a, b) { return v < a ? a : v > b ? b : v; }
	function rampe(p, a, b) { return klemm((p - a) / (b - a), 0, 1); }
	function sanft(x) { x = 1 - klemm(x, 0, 1); return 1 - x * x * x; } /* ≈ cubic-bezier(.22,.61,.36,1) */
	function el(tag, cls, text, zu) {
		var n = D.createElement(tag);
		if (cls) n.className = cls.split(' ').map(c => 'rk-reise__' + c).join(' ');
		if (text != null) n.textContent = text;
		if (zu) zu.appendChild(n);
		return n;
	}
	function attr(n, o) { for (var k in o) n.setAttribute(k, o[k]); return n; }
	function istText(s) { return typeof s == 'string' && s.trim() !== ''; }
	function texte(a) { return Array.isArray(a) ? a.filter(istText) : []; }
	function istBox(b) {
		return Array.isArray(b) && b.length === 4 && b.every(v => typeof v == 'number' && v >= 0 && v <= 1) && b[2] - b[0] > .02 && b[3] - b[1] > .02;
	}
	function fern(u) { return /^(https?:)?\/\//i.test(u); }
	function breite(u, w) { return fern(u) ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : u; }
	function setz(n, k, v) { var c = n._rk || (n._rk = {}); if (c[k] !== v) n.style[k] = c[k] = v; }
	/* v: bleibt fokussierbar */
	function deck(n, o, v) { setz(n, 'opacity', o > .999 ? '1' : o.toFixed(3)); setz(n, 'visibility', o < .002 && !v ? 'hidden' : ''); }
	function hoch(n, y) { setz(n, 'transform', `translateY(${y.toFixed(1)}px)`); }
	function skal(n, s) { setz(n, 'transform', `scale(${s.toFixed(4)})`); }
	function pos(s, l, t, w, h) { s.left = l + 'px'; s.top = t + 'px'; s.width = w + 'px'; s.height = h + 'px'; }
	function zahl(n) { return String(M.round(n * 10) / 10).replace('.', ','); }
	function gruppe(d) { return { role: 'group', 'aria-label': 'Die Reise ins Kristall' + (d.name ? ': ' + d.name : '') }; }
	function nah(d, i) { return (d.name ? d.name + ', ' : '') + 'Nahaufnahme ' + i; }

	function lesen(sec) {
		var s = sec.querySelector('.rk-erl__daten'), d, m, t = [];
		try { d = JSON.parse(s.textContent); } catch (x) { return null; }
		if (!d || !istText(d.bild_an)) return null;
		m = d.masse || {};
		if (m.breite_cm > 0) t.push('Breite ' + zahl(+m.breite_cm) + ' cm');
		if (m.hoehe_cm > 0) t.push('Höhe ' + zahl(+m.hoehe_cm) + ' cm');
		return {
			name: istText(d.name) ? d.name : '', an: d.bild_an, solo: istText(d.bild_buehne) ? d.bild_buehne : null,
			sbox: istBox(d.buehne_box) ? d.buehne_box : [.03, .03, .97, .97], box: istBox(d.box) ? d.box : [.2, .02, .8, .62],
			det: texte(d.details).slice(0, 2), zeilen: texte(d.zeilen).slice(0, 4), masse: t.join(' · ')
		};
	}

	/* fehlt ein Kapitel, wächst das vorige */
	function planen(d) {
		var N = d.det.length, z = d.zeilen, Z = z.length, kap = [], sl = [], hat = [1, 1, N || Z > 1, N > 1 || Z > 2, 1];
		[0, .2, .45, .65, .85].forEach((a, i) => { if (hat[i]) kap.push({ a }); });
		kap.forEach((k, j) => { k.b = (kap[j + 1] || { a: 1 }).a; k.n = ROEM[j]; });
		if (Z) sl.push({ t: z[0], a: .2, b: hat[2] ? .45 : .85 });
		if (Z > 1) sl.push({ t: z[1], a: .45, b: hat[3] ? .65 : .85 });
		if (Z > 3) sl.push({ t: z[2], a: .65, b: .75 }, { t: z[3], a: .75, b: .85 });
		else if (Z > 2) sl.push({ t: z[2], a: .65, b: .85 });
		return { kap, sl, endeII: N ? .45 : .85, det: N > 1 ? [[.45, .65], [.65, .85]] : N ? [[.45, .85]] : [] };
	}

	/* Bilder laden erst in der Nähe der Section */
	function bild(st, u, cls, alt, g, f, zu) {
		var i = attr(el('img', cls, null, zu), { alt: alt || '', decoding: 'async' });
		st.bilder.push({ i, u, g, f });
		return i;
	}
	function laden(st) {
		st.bilder.forEach(b => {
			var i = b.i;
			i.addEventListener('load', () => { i.classList.add('ist-da'); if (b.f) b.f(i); }, { once: true });
			if (fern(b.u)) {
				i.sizes = M.max(160, M.ceil(b.g())) + 'px';
				i.srcset = [480, 750, 1100, 1500].map(w => `${breite(b.u, w)} ${w}w`).join(', ');
			}
			i.src = breite(b.u, 1100);
		});
	}

	function kopfHoehe() {
		var h = 0;
		D.querySelectorAll('.shopify-section-group-header-group').forEach(n => {
			var cs = getComputedStyle(n), hh = n.offsetHeight;
			if (/sticky|fixed/.test(cs.position) && hh && hh < innerHeight * .3) h = M.max(h, (parseFloat(cs.top) || 0) + hh);
		});
		return M.round(h);
	}

	function link(st, zu) {
		var a = el('a', 'link', 'Ausführung wählen ', zu);
		attr(el('span', null, '↑', a), AH);
		a.href = '#MainProduct';
		auf(a, 'click', ev => {
			/* #ProductOptions-… hat tabindex=-1 */
			var z = D.querySelector('#MainProduct,[id^="ProductOptions-"],[data-product-form]');
			ev.preventDefault();
			scrollTo({ top: z ? M.round(z.getBoundingClientRect().top + pageYOffset - kopfHoehe()) : 0, behavior: st.ruhig ? 'auto' : 'smooth' });
			if (z) z.focus({ preventScroll: true });
		});
		return a;
	}

	function bauFilm(st) {
		var d = st.d, P = st.plan, e = st.e = {}, n = P.kap.length, rb;
		var gr = () => st.g ? st.g.Wi * M.max(1.35, st.g.s2 * 1.03) : 1500;
		var kl = e.klebe = el('div', 'klebe'), bu = e.buehne = attr(el('div', 'buehne', null, kl), gruppe(d));
		var ne = e.neigung = el('div', 'neigung', null, bu), sz = e.szene = el('div', 'szene', null, ne), fl = el('div', 'flaeche', null, sz);
		st.root.classList.add('rk-reise--film');

		/* Rahmen in V: geladene Fassung, kein 2. Download */
		e.raum = bild(st, d.an, 'raum', d.name, gr, i => { sz.classList.add('ist-da'); rb.src = i.currentSrc || i.src; }, fl);
		if (d.solo) {
			e.solo = el('div', 'solo', null, ne);
			bild(st, d.solo, 'lade', d.name, () => st.g ? st.g.sw : 1100, i => {
				if (i.naturalHeight) { st.arSolo = i.naturalWidth / i.naturalHeight; neuMessen(st); }
			}, e.solo);
		} else e.objekt = bild(st, d.an, 'objekt', '', gr, null, fl);

		e.det = d.det.map((u, i) => {
			var w = el('div', 'detail', null, bu);
			bild(st, u, 'lade', nah(d, i + 1), () => st.g ? M.max(st.g.W, st.g.H) : 1100, null, w);
			return w;
		});
		el('div', 'schleier schleier--u', null, bu);
		e.schleierO = el('div', 'schleier schleier--o', null, bu);
		e.kopf = el('div', 'kopf', null, bu);
		el('p', 'label', 'Die Reise', e.kopf);
		if (d.name) el('h2', 'titel', d.name, e.kopf);
		/* Screenreader-Fassung; animierte Kopien aria-hidden */
		var sr = el('ul', 'sr', null, bu);
		d.zeilen.concat(d.masse || []).forEach(t => el('li', null, t, sr));
		e.zeilen = P.sl.map(s => attr(el('p', 'zeile', s.t, bu), AH));

		var le = el('div', 'leiste', null, bu);
		e.ziffer = attr(el('span', 'ziffer', 'I', le), AH);
		var sch = attr(el('div', 'schiene', null, le), { role: 'group', 'aria-label': 'Kapitel' });
		e.fuellung = el('span', 'fuellung', null, sch);
		e.marken = P.kap.map((k, j) => {
			var b = attr(el('button', 'marke', null, sch), { type: 'button', 'aria-label': 'Kapitel ' + k.n });
			b.style.left = k.a * 100 + '%';
			auf(b, 'click', () => springen(st, j));
			return b;
		});

		/* nach der Leiste: Tab von Marke V → Link → Kapitel V */
		e.ende = el('div', 'ende', null, bu);
		e.rahmen = el('div', 'rahmen', null, e.ende);
		rb = attr(el('img', null, null, e.rahmen), { alt: '', decoding: 'async' });
		e.endTexte = [['endname', d.name], ['masse', d.masse]].filter(x => x[1]).map(x => attr(el('p', x[0], x[1], e.ende), AH));
		e.endTexte.push(e.link = link(st, e.ende));
		auf(e.link, 'focus', () => { if (st.p < .9) springen(st, n - 1); });

		/* Neigung: Maus bzw. Handy (iOS erst nach Geste) */
		auf(bu, 'pointermove', ev => {
			if (ev.pointerType !== 'mouse') return;
			var r = bu.getBoundingClientRect();
			st.zx = klemm((ev.clientX - r.left) / r.width * 2 - 1, -1, 1);
			st.zy = klemm((ev.clientY - r.top) / r.height * 2 - 1, -1, 1);
			if (st.w) wecken(st);
		});
		auf(bu, 'pointerleave', () => { st.zx = st.zy = 0; wecken(st); });
		auf(bu, 'click', erfragen);
		return kl;
	}

	/* reduced motion: Bilder untereinander */
	function bauRuhig(st) {
		var d = st.d, w = attr(el('div', 'ruhig'), gruppe(d)), urls = [d.solo || d.an].concat(d.det), ab;
		var breit = () => M.min(st.root.clientWidth || 720, 720);
		st.root.classList.add('rk-reise--ruhig');
		el('p', 'label', 'Die Reise', w);
		if (d.name) el('h2', 'titel', d.name, w);
		urls.forEach((u, i) => {
			var f = el('figure', i || !d.solo ? 'tafel' : 'tafel tafel--solo', null, w);
			bild(st, u, 'lade', i ? nah(d, i) : d.name, breit, null, f);
			if (d.zeilen[i]) el('figcaption', 'zeile', d.zeilen[i], f);
		});
		d.zeilen.slice(urls.length).forEach(z => el('p', 'zeile', z, w));
		ab = el('div', 'abschluss', null, w);
		if (d.masse) el('p', 'masse', d.masse, ab);
		link(st, ab);
		return w;
	}

	/* bild_an ist quadratisch */
	function messen(st) {
		var e = st.e, d = st.d, rs = st.root.style, f = D.querySelector('[data-sticky-atc]');
		var vv = (k, v) => rs.setProperty('--rk-' + k, v.toFixed(1) + 'px');
		vv('kopf', st.kopf = kopfHoehe());
		/* Kaufleiste: Platz immer freihalten */
		vv('fuss', f && getComputedStyle(f).position === 'fixed' ? f.offsetHeight : 0);
		var W = e.buehne.clientWidth, H = e.buehne.clientHeight;
		st.weg = st.root.offsetHeight - e.klebe.offsetHeight;
		if (!W || !H) return;
		var Wi = M.max(W, H), b = d.box;
		var bx = (b[0] + b[2]) / 2 * Wi, by = (b[1] + b[3]) / 2 * Wi, bw = (b[2] - b[0]) * Wi, bh = (b[3] - b[1]) * Wi;
		var L = klemm(W / 2 - bx, W - Wi, 0), T = klemm(H * .46 - by, H - Wi, 0);
		var oben = H * .05, rh = H - M.max(150, H * .2) - oben;
		var g = st.g = {
			W, H, Wi, L, T, bx, by, pcx: L + bx, pcy: T + by, qx: W / 2, qy: oben + rh / 2,
			s2: klemm(M.min(rh / bh, W * .9 / bw), .5, 5), fin: M.round(klemm(M.min(W - 80, H - 300, 560), 160, 560))
		};
		g.sI = 1 + .35 * klemm((g.s2 - .9) / .45, 0, 1); /* kein Rückzoom in II */
		pos(e.szene.style, L, T, Wi, Wi);
		/* Maske; unter mb (Unterkante) kein Raum */
		[['mx', bx], ['my', b[1] * Wi + bh * .52], ['mb', b[3] * Wi], ['mrx', bw * .75], ['mry', bh * .8], ['fin', g.fin]].forEach(v => vv(v[0], v[1]));
		e.neigung.style.transformOrigin = `${g.qx}px ${g.qy}px`;
		if (e.solo) {
			var sa = st.arSolo, sb = d.sbox, sh = M.min(rh / (sb[3] - sb[1]), W * .9 / ((sb[2] - sb[0]) * sa));
			g.sw = sh * sa;
			pos(e.solo.style, g.qx - (sb[0] + sb[2]) / 2 * g.sw, g.qy - (sb[1] + sb[3]) / 2 * sh, g.sw, sh);
		}
	}
	function neuMessen(st) { if (st.e && !st.ruhig) { messen(st); zeichnen(st); } }

	function zeichnen(st) {
		var g = st.g, e = st.e, P = st.plan, p = st.p, aus = rampe(p, .82, .88), s, cx, cy, t, k, m, j = 0, oL = 0, zu = 0;
		if (!g) return;
		if (p <= .2) { /* I: Push-in */
			s = 1 + (g.sI - 1) * sanft(p / .2);
			cx = g.pcx; cy = g.pcy;
		} else { /* II: Leuchter in die Bühnenmitte */
			t = sanft(rampe(p, .2, .38));
			s = g.sI * M.pow(g.s2 / g.sI, t) * (1 + .03 * rampe(p, .38, P.endeII));
			cx = g.pcx + (g.qx - g.pcx) * t;
			cy = g.pcy + (g.qy - g.pcy) * t;
		}
		setz(e.szene, 'transform', `translate(${(cx - g.L - s * g.bx).toFixed(1)}px,${(cy - g.T - s * g.by).toFixed(1)}px) scale(${s.toFixed(4)})`);

		/* Ebenen unten → oben: [Element, Deckkraft, deckt] */
		var eb = [[e.raum, 1 - rampe(p, .2, .31)]];
		if (e.objekt) eb.push([e.objekt, rampe(p, .17, .23)]);
		if (e.solo) {
			eb.push([e.solo, rampe(p, .2, .28)]);
			skal(e.solo, (1 + .05 * (1 - sanft(rampe(p, .2, .36)))) * (1 + .02 * rampe(p, .36, P.endeII)));
		}
		e.det.forEach((n, i) => {
			var a = P.det[i][0], l = sanft(rampe(p, a - .03, a + .1)), bl = 6 * (1 - l);
			eb.push([n, rampe(p, a - .03, a + .03), 1]);
			skal(n, (1 + .18 * (1 - l)) * (1 + .02 * rampe(p, a + .1, P.det[i][1])) * (1 - .04 * aus));
			setz(n, 'filter', bl > .05 ? `blur(${bl.toFixed(1)}px)` : 'none');
		});
		for (k = eb.length - 1; k >= 0; k--) {
			deck(eb[k][0], zu ? 0 : eb[k][1] * (1 - aus));
			if (eb[k][2] && eb[k][1] > .999) zu = 1;
		}

		st.w = rampe(p, .2, .3) * (1 - rampe(p, P.endeII - .03, P.endeII + .03));
		setz(e.neigung, 'transform', `perspective(1200px) rotateX(${(-st.ny * 3 * st.w).toFixed(2)}deg) rotateY(${(st.nx * 3 * st.w).toFixed(2)}deg)`);

		var ok = 1 - rampe(p, .12, .18); /* nie mehr als ein Satz zugleich */
		deck(e.kopf, ok);
		deck(e.schleierO, ok);
		hoch(e.kopf, -10 * (1 - ok));
		e.zeilen.forEach((n, i) => { /* Rampen relativ zur Slotlänge */
			var sl = P.sl[i], L = sl.b - sl.a, ein = rampe(p, sl.a + L * .08, sl.a + L * .28), weg = rampe(p, sl.b - L * .18, sl.b - L * .03);
			deck(n, ein * (1 - weg));
			hoch(n, 14 * (1 - sanft(ein)) - 8 * weg);
		});

		var eo = rampe(p, .85, .91); /* V */
		deck(e.ende, eo, 1);
		skal(e.rahmen, 1 + .06 * (1 - sanft(eo)));
		e.endTexte.forEach((n, i) => {
			var o = rampe(p, .89 + i * .02, .93 + i * .02);
			deck(n, o, n === e.link);
			hoch(n, 10 * (1 - sanft(o)));
			if (n === e.link) oL = o;
		});
		if (oL > .5 !== st.istEnde) st.root.classList.toggle('ist-ende', st.istEnde = oL > .5);

		setz(e.fuellung, 'transform', `scaleX(${p.toFixed(4)})`);
		P.kap.forEach((kp, i) => { if (p >= kp.a - .001) j = i; });
		if (j !== st.kapAkt) {
			if ((m = e.marken[st.kapAkt])) { m.classList.remove('ist-aktiv'); m.removeAttribute('aria-current'); }
			attr(e.marken[st.kapAkt = j], { 'aria-current': 'step' }).classList.add('ist-aktiv');
			e.ziffer.textContent = P.kap[j].n;
		}
	}

	/* Takt: gedämpft; stoppt in Ruhe */
	function takt(st, now) {
		st.raf = 0;
		if (!st.g || st.ruhig) return;
		var ziel = st.weg > 0 ? klemm((st.kopf - st.root.getBoundingClientRect().top) / st.weg, 0, 1) : 0;
		var dt = st.t ? M.min(now - st.t, 64) : 16, dp = ziel - st.p, kn = 1 - M.exp(-dt / 650);
		st.t = now;
		st.p = M.abs(dp) < .0003 || M.abs(dp) > .25 ? ziel : st.p + dp * (1 - M.exp(-dt / 90));
		st.nx += (st.zx - st.nx) * kn;
		st.ny += (st.zy - st.ny) * kn;
		zeichnen(st);
		if (st.p === ziel && (!st.w || M.abs(st.zx - st.nx) + M.abs(st.zy - st.ny) < .003)) st.t = 0;
		else wecken(st);
	}
	function wecken(st) { if (!st.raf && st.sichtbar && !D.hidden && st.g && !st.ruhig) st.raf = requestAnimationFrame(st.tick); }
	function stopp(st) { if (st.raf) cancelAnimationFrame(st.raf); st.raf = st.t = 0; }

	function springen(st, j) {
		var P = st.plan, k = P.kap[j], ziel = !j ? 0 : j === P.kap.length - 1 ? .97 : M.min(k.a + .14, (k.a + k.b) / 2 + .04);
		scrollTo({ top: M.round(pageYOffset + st.root.getBoundingClientRect().top - st.kopf + ziel * st.weg + 1), behavior: 'smooth' });
	}

	/* Handy-Neigung (Querformat: Achsen getauscht); Ruhelage wandert mit */
	function lage(st, ev) {
		var x = ev.gamma, y = ev.beta, o = window.orientation || 0, t = x; /* 0, ±90, 180 */
		if (x == null || y == null) return;
		if (o % 180) { x = y * o / 90; y = -t * o / 90; }
		if (st.g0 == null || o !== st.o) { st.o = o; st.g0 = x; st.b0 = y; }
		st.g0 += (x - st.g0) * .012;
		st.b0 += (y - st.b0) * .012;
		st.zx = klemm((x - st.g0) / 16, -1, 1);
		st.zy = klemm((y - st.b0) / 16, -1, 1);
		if (st.w) wecken(st);
	}
	function lageAn(st) { if (neig.ok && !st.lageAn && !st.ruhig) { st.lageAn = 1; an('deviceorientation', st.onLage); } }
	function lageAus(st) { if (st.lageAn) { st.lageAn = 0; ab('deviceorientation', st.onLage); } }
	function erfragen(ev) { /* nicht bei Marke/Link */
		if (!fragen || neig.gefragt || ev.target.closest('a,button')) return;
		neig.gefragt = 1;
		DOE.requestPermission().then(r => {
			neig.ok = r === 'granted';
			alle.forEach(st => { if (st.sichtbar) lageAn(st); });
		}, () => {});
	}

	function abbauen(st) {
		stopp(st);
		[st.io1, st.io2].forEach(o => { if (o) o.disconnect(); });
		ab('scroll', st.onScroll);
		ab('resize', st.onResize);
		lageAus(st);
		if (st.bau) st.bau.remove();
		st.root.classList.remove('rk-reise--film', 'rk-reise--ruhig', 'ist-ende');
		st.bau = st.e = st.g = st.kapAkt = null;
		st.bilder = [];
		st.sichtbar = st.istEnde = false;
	}

	function aufbauen(st) {
		abbauen(st);
		st.ruhig = mq.matches;
		st.root.appendChild(st.bau = st.ruhig ? bauRuhig(st) : bauFilm(st));
		st.io1 = new IntersectionObserver(en => {
			if (en.some(x => x.isIntersecting)) { st.io1.disconnect(); laden(st); }
		}, { rootMargin: '150% 0px' });
		st.io1.observe(st.root);
		if (st.ruhig) return;
		messen(st);
		zeichnen(st);
		an('resize', st.onResize);
		st.io2 = new IntersectionObserver(en => {
			var s = en[en.length - 1].isIntersecting;
			if (s === st.sichtbar) return;
			if ((st.sichtbar = s)) {
				if (!st.g) neuMessen(st);
				an('scroll', st.onScroll);
				lageAn(st);
				wecken(st);
			} else {
				ab('scroll', st.onScroll);
				lageAus(st);
				stopp(st);
			}
		});
		st.io2.observe(st.root);
	}

	function starten(sec) {
		if (sec.dataset.rkInit) return;
		sec.dataset.rkInit = '1';
		var root = sec.querySelector('.rk-reise') || el('div', null, null, sec), d = lesen(sec), rz = 0, st;
		root.classList.add('rk-reise');
		if (!d) return root.classList.add('rk-reise--leer');
		st = { sec, root, d, plan: planen(d), arSolo: 1, p: 0, nx: 0, ny: 0, zx: 0, zy: 0 };
		st.tick = t => takt(st, t);
		st.onScroll = () => wecken(st);
		st.onLage = ev => lage(st, ev);
		st.onResize = () => { if (!rz) rz = requestAnimationFrame(() => { rz = 0; neuMessen(st); wecken(st); }); };
		alle.push(st);
		aufbauen(st);
	}

	function init(w) {
		w = w && w.querySelectorAll ? w : D;
		if (w.matches && w.matches(SEL)) starten(w);
		w.querySelectorAll(SEL).forEach(starten);
	}

	auf(D, 'shopify:section:load', ev => init(ev.target));
	auf(D, 'shopify:section:unload', ev => {
		alle = alle.filter(st => { var weg = ev.target.contains(st.sec); if (weg) abbauen(st); return !weg; });
	});
	if (D.readyState === 'loading') auf(D, 'DOMContentLoaded', () => init());
	else init();
})();
